import React, { useState, useMemo, useEffect } from 'react';
import {
  Box,
  IconButton,
  useTheme,
  InputAdornment,
  TextField,
  Button,
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { makeStyles } from '@material-ui/styles';
import { useIntl } from 'umi';
import { useDispatch, useSelector } from 'dva';
import { useForm, Controller } from 'react-hook-form';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ReplayIcon from '@material-ui/icons/Replay';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import SearchIcon from '@material-ui/icons/Search';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import webStorage from '@/utils/storageManager';
import { fmtThousand } from '@/utils/comUtil';
import CouponModalStyled from './CouponModalStyled';
import DataTableNativeML from '@/components/DataTableNativeML';
import InitPaginationML from '@/components/InitPaginationML';
import ClearIconML from '@/components/ClearIconML/index';

export default (props) => {
  const theme = useTheme();
  //会员等级列表
  const memberLevels =
    useSelector((state) => state.luckDrawViewSetting.memberLevels) || [];
  //礼品类别
  const ACTIVITY_POINTS_GIFT_TYPE =
    webStorage.get('DICTOBJ')?.ACTIVITY_POINTS_GIFT_TYPE?.map((item) => ({
      ...item,
      nameZh: item.nameZh === '实物' ? '实物邮寄' : item.nameZh,
    })) || [];
  const MEMBER_TYPE = webStorage.get('DICTOBJ')?.MEMBER_TYPE || [];
  console.log('MEMBER_TYPE', MEMBER_TYPE);
  const useStyles = makeStyles(() => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      position: 'absolute',
      width: 960,
      height: 800,
      padding: '24px 32px',
      background: '#fff',
      boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.08)',
      borderRadius: '12px',
    },
  }));
  const loadingEffect = useSelector((state) => state.loading);
  const couponLoading =
    loadingEffect.effects['managementGoodsShelfForm/getGiftList'];
  const classes = useStyles();
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;

  //规则名称
  const [ruleName, setRuleName] = useState();
  const [memberType, setMemberType] = useState('');
  const [leftStartPointValue, setLeftStartPointValue] = useState('');
  const [leftEndPointValue, setLeftEndPointValue] = useState('');
  const [levelValue, setLevelValue] = useState([]);
  const { control, setValue } = useForm({});

  const dispatch = useDispatch();
  const { selectedIds: defaultIdList, onConfirm, open, onClose, title } = props;

  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });

  // 存储选中的数据
  const [selectedIdList, setSelectedIdList] = useState(defaultIdList);
  const fetchGiftPage = () => {
    dispatch({
      type: 'managementGoodsShelfForm/getGiftList',
      payload: {
        values: {
          title: ruleName,
          memberType: memberType,
          memberLevels: levelValue ? levelValue.map((i) => i.code) : null,
          leftStartPoint: leftStartPointValue,
          leftEndPoint: leftEndPointValue,
          pageNum: pageData.pageNum,
          pageSize: pageData.pageSize,
          status: 'UNENFORCED_VALID',
        },
      },
    });
  };
  const fetchGiftPageRest = () => {
    dispatch({
      type: 'managementGoodsShelfForm/getGiftList',
      payload: {
        values: {
          title: '',
          MEMBER_TYPE: null,
          leftStartPointValue: '',
          leftEndPointValue: '',
          pageNum: 1,
          memberLevels: null,
          pageSize: pageData.pageSize,
          status: 'UNENFORCED_VALID',
        },
      },
    });
  };

  useEffect(() => {
    fetchGiftPage();
  }, []);

  const giftList =
    useSelector((state) => state.managementGoodsShelfForm?.giftList) || {};
  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };
  const handleClose = () => {
    onClose();
  };

  const onSubmit = () => {
    onConfirm(selectedIdList);

    onClose();
  };

  const columns = [
    {
      type: 'checkbox',
      align: 'right',
      width: 80,
      onChange: (a, b, c) => {
        const data = [...selectedIdList, ...c];
        let chooseArr = [];
        data.forEach((item) => {
          const findItem = chooseArr.some((it) => item.id === it.id);
          if (a.includes(item.id) && !findItem) {
            chooseArr.push(item);
          }
        });
        setSelectedIdList(chooseArr);
      },
    },
    {
      title: '礼品code',
      align: 'center',
      id: 'code',
      key: 'code',
    },
    {
      title: '礼品标题',
      id: 'title',
      width: 145,
      align: 'center',
      key: 'title',
    },
    {
      title: '礼品类型',
      align: 'center',
      id: 'subTitle',
      key: 'subTitle',
      width: 145,
      render: ({ type }) => {
        return ACTIVITY_POINTS_GIFT_TYPE?.find((i) => i.nameEn === type)
          ?.nameZh;
      },
    },
    {
      title: '礼品状态',
      align: 'center',
      id: 'cost',
      key: 'cost',
      width: 135,
      render: (row) => {
        return row.status === 'VALID'
          ? '生效中'
          : row.status === 'UNENFORCED'
          ? '未生效'
          : '已失效';
      },
    },
    {
      title: '兑换积分',
      align: 'center',
      id: 'points',
      key: 'points',
      width: 135,
      render: (row) => {
        return row.points || Number(row.points) === 0
          ? fmtThousand(row.points)
          : '-';
      },
    },
    {
      title: '兑换金额',
      align: 'center',
      id: 'cost',
      key: 'cost',
      width: 135,
      render: (row) => {
        return row.cost || Number(row.cost) === 0 ? fmtThousand(row.cost) : '-';
      },
    },
    {
      title: '剩余库存',
      align: 'center',
      id: 'surplusStock',
      key: 'surplusStock',
      width: 135,
      render: (row) => {
        return row.surplusStock || Number(row.surplusStock) === 0
          ? fmtThousand(row.surplusStock)
          : '-';
      },
    },
  ];

  const giftListString =
    giftList && Array.isArray(giftList)
      ? giftList.map((item) => ({ ...item, id: String(item.id) }))
      : [];

  const hasNext = useMemo(() => {
    if (!giftListString) {
      return false;
    }
    if (
      pageData.pageNum === 1 &&
      giftListString.length > pageData.pageSize + 1
    ) {
      return true;
    }
    if (pageData.pageNum * pageData.pageSize < giftListString.length) {
      return true;
    }
    return false;
  }, [pageData.pageNum, giftListString?.length]);

  const dataList = useMemo(() => {
    if (!giftListString) {
      return [];
    }
    const data = [...giftListString];
    const page = data.splice(
      (pageData.pageNum - 1) * pageData.pageSize,
      pageData.pageSize,
    );
    return page || [];
  }, [pageData.pageNum, giftListString?.length]);

  const handleClearVipType = () => {
    setMemberType('');
  };

  const handleRestClick = () => {
    setRuleName('');
    setMemberType('');
    setLeftStartPointValue('');
    setLeftEndPointValue('');
    setLevelValue([]);
    setPageData({ ...pageData, pageNum: 1 });
    fetchGiftPageRest();
  };

  return (
    <CouponModalStyled
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      theme={theme}
      className={classes.modal}
    >
      <Box className={classes.paper}>
        <Box className="first_line">
          <div className="title">{title || '选择礼品'}</div>
          <div className="close">
            <SvgIconML
              size={20}
              name={'modalClose'}
              onClick={props.onClose}
              fill="#212121"
            />
          </div>
        </Box>
        <Box mb={2} mt={2} sx={{ display: 'flex', gap: '0 48px' }}>
          <Box className="search_wrapper">
            <TextField
              value={ruleName}
              onChange={(e) => {
                setRuleName(e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        setRuleName('');
                      }}
                      edge="end"
                    >
                      {ruleName && <ClearIcon className="clear-icon" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              id="basic"
              variant="standard"
              className="input search_width392"
              label="礼品标题"
              placeholder="请输入礼品标题"
              defaultValue={''}
            />
            <Controller
              render={() => (
                <Autocomplete
                  id="disable-close-on-select"
                  disableCloseOnSelect
                  className="companies search_width search_width200"
                  options={memberLevels || []}
                  multiple
                  limitTags={1}
                  value={levelValue}
                  name="levelValue"
                  getOptionLabel={(option) => option?.name}
                  renderOption={(pro, option, { selected }) => {
                    return (
                      <li {...pro}>
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          style={{
                            height: '12px',
                            width: '12px',
                            marginRight: 8,
                          }}
                          checked={selected}
                        />
                        {option?.name}
                      </li>
                    );
                  }}
                  onChange={(e, newValue, Type) => {
                    if (Type === 'clear') {
                      setLevelValue([]);
                      setValue('levelValue', null);
                    }
                    const ids = newValue.map((i) => i.code);
                    setLevelValue(newValue);
                    setValue('levelValue', ids);
                  }}
                  clearOnBlur
                  renderInput={(param) => (
                    <TextField
                      {...param}
                      label="可兑换等级"
                      variant="standard"
                    />
                  )}
                />
              )}
              label="可兑换等级"
              name="levelValue"
              variant="standard"
              control={control}
              defaultValue={[]}
            />

            <FormControl className="search_width" variant="standard">
              <InputLabel>会员类型</InputLabel>
              <Select
                label="新老会员类型"
                className="select"
                value={memberType}
                onChange={(e) => {
                  setMemberType(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        className="clear-btn"
                        onClick={() => setMemberType('')}
                        edge="end"
                      >
                        <ClearIcon className="clear-icon" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              >
                {MEMBER_TYPE.map((item) => (
                  <MenuItem
                    key={item.dictCode}
                    value={item.dictCode}
                    name={item.nameZh}
                  >
                    {item.nameZh}
                  </MenuItem>
                ))}
              </Select>
              <ClearIconML
                handleClick={handleClearVipType}
                clearValue={memberType}
              ></ClearIconML>
            </FormControl>
            <Box
              className="search_width search_width_integral"
              sx={{
                display: 'flex',
                gap: '0 14px',
                alignItems: 'flex-end',
                color: '#616161',
              }}
            >
              <TextField
                value={leftStartPointValue}
                onChange={(e) => {
                  setLeftStartPointValue(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className="clear-btn"
                        onClick={() => {
                          setLeftStartPointValue('');
                          // setRuleName();
                          // setName();
                          // setPageData({ ...pageData, pageNum: 1 });
                        }}
                        edge="end"
                      >
                        {leftStartPointValue && (
                          <ClearIcon className="clear-icon" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="standard"
                label="剩余可用积分"
                className="rule_name"
              />
              <Box>至</Box>
              <TextField
                value={leftEndPointValue}
                name="leftEndPoint"
                onChange={(e) => {
                  // setRuleName(e.target.value);
                  setLeftEndPointValue(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className="clear-btn"
                        onClick={() => {
                          setLeftEndPointValue('');
                        }}
                        edge="end"
                      >
                        {leftEndPointValue && (
                          <ClearIcon className="clear-icon" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="standard"
                label="剩余可用积分"
                className="rule_name"
              />
            </Box>
          </Box>
          <Box
            className="button-group"
            sx={{
              width: '300px',
              display: 'flex',
              justifyContent: 'space-around',
              flexShrink: 0,
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              variant="contained"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
              onClick={() => {
                fetchGiftPage();
              }}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
        <Box className="table">
          <DataTableNativeML
            loading={couponLoading}
            columns={columns}
            chooseIds={
              selectedIdList &&
              Array.isArray(selectedIdList) &&
              selectedIdList.length > 0
                ? selectedIdList.map((item) => item.id)
                : []
            }
            changePage={changePage}
            page={pageData}
            data={dataList}
            columnKey="id"
            total={giftListString?.length}
            paging={true}
            devicesMinWidth="auto"
            control={control}
            pageButton={false}
          ></DataTableNativeML>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box
            sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}
          >
            <InitPaginationML
              hasNext={hasNext}
              page={pageData}
              total={giftListString?.length}
              changePages={changePage}
              showPagingDataStatus={true}
              pages={Math.ceil(giftListString?.length / pageData.pageSize)}
              showPageColor={true}
            />
          </Box>
          <div className="modal-btn-wrap">
            <Button onClick={handleClose} variant="contained" color="secondary">
              {formatMessage({ id: 'comm.action.btn.08' })}
            </Button>
            <Button
              variant="contained"
              className="btnSubmit button"
              onClick={onSubmit}
            >
              {formatMessage({ id: 'comm.action.btn.07' })}
            </Button>
          </div>
        </Box>
      </Box>
    </CouponModalStyled>
  );
};
